<template>
    <div>
        <ConfirmDialog
            :is-open="confirmRemoveDockReservationDialog"
            :data="dockReservation"
            @on-confirm="removeDockReservation(dockReservation)"
            @on-abort="closeConfirmRemoveDockReservationDialog"
        >
            <template #title>
                Usuwanie rezerwacji
            </template>
            <template #content>
                Czy na pewno chcesz usunąć rezerwację?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>

        <v-dialog
            :value="isOpen"
            max-width="500px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Usuwanie rezerwacji
                    </h1>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="dockReservation"
                                :items="dockReservations"
                                return-object
                                outlined
                                hide-details
                                item-value="id"
                                label="Rezerwacje"
                            >
                                <template slot="selection" slot-scope="data">
                                    {{ formatDate(data.item.start, data.item.end) }}
                                </template>

                                <template slot="item" slot-scope="data">
                                    {{ formatDate(data.item.start, data.item.end) }}
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="info"
                        text
                        data-sentry-label="Anuluj"
                        @click="onClose()"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Usuń"
                        :disabled="isNewDockReservation"
                        @click="showRemoveDockReservationDialog()"
                    >
                        Usuń
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { isEmpty } from 'lodash'
import { errorHandler } from '@/utils/errorHandler'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import { format } from 'date-fns'

export default {
    name: 'DeleteNotificationDialog',
    components: {
        ConfirmDialog
    },
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            dockReservation: {},
            confirmRemoveDockReservationDialog: false,
        }
    },
    computed: {
        dockReservations() {
            return this.$store.state.shipping.notification.notification.dockReservations
        },
        docks() {
            return this.$store.state.shipping.notification.notification.docks
        },
        isNewDockReservation() {
            return isEmpty(this.dockReservation)
        },
    },
    methods: {
        removeDockReservation() {
            this.$store.dispatch('shipping/notification/deleteNotification', this.dockReservation.id )
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeConfirmRemoveDockReservationDialog()
                    this.onClose()
                })
        },
        onClose() {
            this.$emit('close-delete-notification-dialog')
            this.$store.dispatch('shipping/notification/clearBusinessHours')
            setTimeout(() => {
                this.dockReservation = {}
            }, 500)
        },
        formatDate(start, end) {
            return `${format(new Date(start), 'YYYY-MM-DD')}, ${format(new Date(start), 'HH:mm')} - ${format(new Date(end), 'HH:mm')}`
        },
        showRemoveDockReservationDialog() {
            this.confirmRemoveDockReservationDialog = true
        },
        closeConfirmRemoveDockReservationDialog() {
            this.confirmRemoveDockReservationDialog = false
        },
    }
}
</script>

